module.exports = __webpack_public_path__ + "static/img/7.8db050d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/7.png
// module id = D12I
// module chunks = 0